



















import { Component, Vue } from "vue-property-decorator"
import { Howl } from "howler"
import OverviewElement from "./OverviewElement.vue"

@Component({
  components: {
    OverviewElement
  }
})
export default class Overview extends Vue {
  // Decorators: https://github.com/kaorun343/vue-property-decorator
  // Class: https://github.com/vuejs/vue-class-component
  protected dismiss() {
    if (!this.$store.state.muted) {
      new Howl({
        src: ["/audio/Notification.mp3"]
      }).play()
    }
    this.$store.dispatch("overviewOver")
  }

  get formattedResources() {
    const foo = []
    const irange = Math.ceil(this.$store.state.energySources.length / 5)
    for (let i = 0; i < irange; i++) {
      const bar = []
      for (let j = 5 * i; j < 5 * (i + 1); j++) {
          bar.push(this.$store.state.energySources[j])
      }
      foo.push(bar)
    }
    return foo
  }
}
